import { useState, useCallback } from 'react';
import type { BlueprintStage, ProcessBlueprint } from '../../../types/processBlueprint';
import { updateBlueprintStages } from '../services/blueprint.service';

interface UseBlueprintStageMutationsReturn {
  updateStages: (blueprintId: string, stages: BlueprintStage[]) => Promise<ProcessBlueprint>;
  isPending: boolean;
  error: Error | null;
}

export function useBlueprintStageMutations(organizationId: string): UseBlueprintStageMutationsReturn {
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateStages = useCallback(
    async (blueprintId: string, stages: BlueprintStage[]): Promise<ProcessBlueprint> => {
      setIsPending(true);
      setError(null);
      try {
        const result = await updateBlueprintStages(blueprintId, organizationId, stages);
        return result;
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setIsPending(false);
      }
    },
    [organizationId],
  );

  return { updateStages, isPending, error };
}
